var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg403Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 233,
    viewBox: "0 0 252 233",
    width: 252,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 145,
    cy: 117,
    r: 40
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    height: "331.2%",
    width: "331.2%",
    x: "-115.6%",
    y: "-109.4%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    type: "matrix",
    values: "0 0 0 0 0.458823529   0 0 0 0 0.494117647   0 0 0 0 0.529411765  0 0 0 0.203747736 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    height: "331.2%",
    width: "331.2%",
    x: "-115.6%",
    y: "-109.4%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    type: "matrix",
    values: "0 0 0 0 0.458823529   0 0 0 0 0.494117647   0 0 0 0 0.529411765  0 0 0 0.203747736 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 157,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 58,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 66,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b1bbbd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 117,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 193,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 59,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.832 103.776v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.832 43.776v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.832 173.776v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#b1bbbd",
    fillRule: "evenodd",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 88)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m86 122h47v12h-47z",
    fill: "#acb6b8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403Error);
export default __webpack_public_path__ + "static/media/403-error.f9d9a550d3704b159f175e0138029723.svg";
export { ForwardRef as ReactComponent };